module.exports = __webpack_public_path__ + "img/icon_5_42.b7f9bb07.png";